import * as Yup from 'yup';
import moment from 'moment-timezone';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const YupValidators = {
  isPhoneNumber: (optional?: boolean, schema = Yup.string()) =>
    schema.test('isPhoneNumber', 'form.errors.invalidPhoneNumber', (val) => {
      if (!val) {
        return !!optional;
      }

      if (val.length < 6 && optional) {
        return true;
      }

      const phoneNumber = parsePhoneNumberFromString(val);
      if (!phoneNumber) {
        return false;
      }

      return phoneNumber.isValid();
    }),
  isDateValid: () =>
    Yup.string().test(
      'isDateValid',
      'form.errors.invalid',
      (val) => !val || moment(val).isValid(),
    ),
  isChecked: (message?: string) =>
    Yup.boolean().test({
      name: 'isChecked',
      test: (value) => !!value,
      message: message ? message : 'participantForm.checkboxError',
    }),
  isValidName: () =>
    Yup.string().matches(/^[^0-9_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]*$/),
};

export const isUUID = (id?: string) =>
  typeof id === 'string' &&
  !!id.match(
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i,
  );
